import { motion } from "framer-motion";
import { Users, Briefcase, ClipboardList } from "lucide-react";

const Moyens = () => {
  const responsibilities = [
    {
      title: "Conduite et Coordination",
      description: "Conduit ou coordonne toutes les activités du PMN",
      icon: <Briefcase className="w-8 h-8" />,
    },
    {
      title: "Participation aux Instances",
      description:
        "Participe à toutes les instances de pilotage et de coordination de la mise en oeuvre du PMN",
      icon: <ClipboardList className="w-8 h-8" />,
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Banner Section */}
      {/* Hero Section */}
      <section className="relative py-24 bg-[#1E3D1A]">
        <div className="absolute inset-0 bg-[url('/images/carrousel3.webp')] opacity-50" />
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">
              UNITÉ DE GESTION DU PROJET (UGP) PMN
            </h1>
            <p className="text-xl text-white/90">
              L'administration générale du PMN est assurée par le Coordonnateur,
              nommé par Décret.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Responsibilities Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16"
            >
              {responsibilities.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="bg-[#1E3D1A] p-3 rounded-lg text-white">
                      {item.icon}
                    </div>
                    <h3 className="text-xl font-bold text-[#1E3D1A]">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </motion.div>

            {/* Team Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="bg-white rounded-2xl p-8 shadow-lg mb-16"
            >
              <div className="flex items-center space-x-4 mb-6">
                <div className="bg-[#1E3D1A] p-3 rounded-lg text-white">
                  <Users className="w-8 h-8" />
                </div>
                <h2 className="text-2xl font-bold text-[#1E3D1A]">
                  Équipe de Coordination
                </h2>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Le Coordonnateur est assisté d'une équipe de coordination
                composée d'un personnel qualifié et expérimenté en nombre
                suffisant. L'équipe de coordination est chargée de superviser
                les activités du PMN et de prendre toutes les mesures
                nécessaires pour assurer une coordination et une gestion
                convenables desdites activités.
              </p>
            </motion.div>

            {/* Image Grid Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
            >
              <div className="relative h-[300px] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/images/moyens/3card1.webp"
                  alt="Moyens 1"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative h-[300px] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/images/moyens/3card2.webp"
                  alt="Moyens 2"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="relative h-[300px] rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="/images/moyens/3card3.webp"
                  alt="Moyens 3"
                  className="w-full h-full object-cover"
                />
              </div>
            </motion.div>

            {/* Certificates Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="text-center"
            >
              <h2 className="text-2xl font-bold text-[#1E3D1A] mb-8">
                Ministre du Tourisme et de l'Artisanat | Projet Mobilier
                National (PMN)
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="relative h-[100px] rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/moyens/cert1.webp"
                    alt="Certificat 1"
                    className="w-full h-full object-contain p-4"
                  />
                </div>
                <div className="relative h-[100px] rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/moyens/snhlm.webp"
                    alt="Certificat 2"
                    className="w-full h-full object-contain p-4"
                  />
                </div>
                <div className="relative h-[100px] rounded-2xl overflow-hidden shadow-lg">
                  <img
                    src="/images/moyens/cert3.webp"
                    alt="Certificat 3"
                    className="w-full h-full object-contain p-4"
                  />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Moyens;
